import type { SweepTypographyVariants } from '@sweep-io/sweep-design/dist/components/Typography/types';
import { DataTableVariant } from './TableTypes';
import { colors } from '@sweep-io/sweep-design';

type DataTableVariantProps = {
  [variant in DataTableVariant]: {
    fontVariant: SweepTypographyVariants;
    cellPadding: string;
    actionsPadding: number;
    minRowHeight: string;
    minRowWidth: string;
    headerFontVariant: SweepTypographyVariants;
    headerFontColor: string;
    fontColor: string;
    disabledFontColor: string;
  };
};

export const dataTableVariants: DataTableVariantProps = {
  [DataTableVariant.medium]: {
    headerFontVariant: 'body',
    fontVariant: 'body',
    headerFontColor: colors.grey[900],
    fontColor: colors.grey[900],
    disabledFontColor: colors.grey[500],
    minRowWidth: '151px',
    cellPadding: '16px 8px 16px 24px',
    actionsPadding: 2,
    minRowHeight: '56px',
  },
  [DataTableVariant.small]: {
    headerFontVariant: 'caption',
    fontVariant: 'caption',
    fontColor: colors.grey[900],
    headerFontColor: colors.grey[900],
    disabledFontColor: colors.grey[500],
    minRowWidth: '96px',
    cellPadding: '8px 0px 8px 16px',
    actionsPadding: 0,
    minRowHeight: '32px',
  },
};
